import { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import HeatmapView from "./HeatmapMap";
import LastLocationMap from "./LastLocationMap";
import { config } from "@/config";

type MapTypes = "lastLocation" | "heatmap";

type CollarMapTabsProps = {
  latitude?: number;
  longitude?: number;
};

function CollarMapTabs({
  latitude = config.map.latitude,
  longitude = config.map.longitude,
}: CollarMapTabsProps) {
  const [selectedMap, setSelectedMap] = useState<MapTypes>("lastLocation");

  return (
    <div className="lg:col-span-2 flex flex-col items-start w-full h-full justify-start rounded-2xl border border-gray-200 overflow-hidden">
      <div className="w-full bg-white">
        <Tabs
          value={selectedMap}
          onChange={(_, newValue) => setSelectedMap(newValue)}
          textColor="primary"
          indicatorColor="primary"
          aria-label="tabs de mapas"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab value="lastLocation" label="Última Localização" />
          <Tab value="heatmap" label="Mapa de Calor" />
        </Tabs>
      </div>

      {selectedMap === "lastLocation" && (
        <LastLocationMap latitude={latitude} longitude={longitude} />
      )}

      {selectedMap === "heatmap" && (
        <HeatmapView latitude={latitude} longitude={longitude} />
      )}
    </div>
  );
}

export default CollarMapTabs;
